// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Router from 'vue-router'
import vueSmoothScroll from 'vue-smoothscroll'
import entryComment from './entryComment'
import commentList from '@/components/tmplate/commentList/commentList'
import commentCountLink from './components/molecules/commentCountLink/commentCountLink'
// import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(vueSmoothScroll)

/* eslint-disable no-new */

// pageType
const urlParams = window.location.search.substring(1).split('&')
const isComment = urlParams.indexOf('ly=cm') >= 0
Vue.prototype.$pageType = (isComment) ? 'comment' : 'entry'

if (isComment) {
  /* コメント一覧 routerはコメント一覧のみ使用 */
  Vue.use(Router)
  const router = new Router({
    // mode: 'history',
    routes: [
      {
        path: '/',
        redirect: 'page1'
      },
      {
        path: '/:page',
        name: 'commentList',
        component: commentList
      }
    ],
    scrollBehavior (to, from, savedPosition) {
      const elm = document.getElementById('commentList')
      let offSetTop = elm.offsetTop
      return { x: 0, y: offSetTop }
    }
  })

  new Vue({
    el: '#entryComment',
    router,
    store,
    components: { entryComment },
    template: '<entryComment/>'
  })
} else {
  /* 記事内コメント */
  new Vue({
    el: '#entryComment',
    store,
    components: { entryComment },
    template: '<entryComment/>'
  })
}

/* 記事コメントリンク 対象要素あれば */
const commentLinkElm = document.getElementById('commentCountLink')
if (commentLinkElm) {
  new Vue({
    el: '#commentCountLink',
    store,
    components: { commentCountLink },
    template: '<commentCountLink/>'
  })
}



// WEBPACK FOOTER //
// ./src/main.js